export function perdonDocReducer( state = '', action ){
    switch( action.type ){
        case "SET_PERSON_DOC" : return action.payload
        default: return state
    }
}


// WEBPACK FOOTER //
// ./src/components/parts/document-component/reducers.js